export default __webpack_public_path__ + "static/media/gallery_05.b5bad533.jpg";